<template>
  <div class="spinner" :class="{ 'spinner-block': block, 'spinner-sm': small, 'show': shown }">
    <div class="spinner-bar"></div>
    <div class="spinner-text" v-if="messageNotEmpty">{{ message }}</div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    block: Boolean,
    small: Boolean
  },
  data () {
    return {
      message: null,
      shown: false
    }
  },
  methods: {
    show (message) {
      this.message = message
      this.shown = true
    },
    hide () {
      this.shown = false
    }
  },
  computed: {
    messageNotEmpty () {
      return !!this.message && this.message.length > 0
    }
  }
}
</script>
